import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { girisYap } from '../services/api';
import kelebek from '../assets/kelebek.png';

export default function Login() {
  const siteId = parseInt(new URLSearchParams(window.location.search).get('siteId')) || 0;
  const navigate = useNavigate();

  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [parola,       setParola]       = useState('');
  const [hata,         setHata]         = useState('');
  const [yukleniyor,   setYukleniyor]   = useState(false);

  if (!siteId) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <div style={{ color:'#a32d2d', fontSize:14 }}>Geçersiz bağlantı. Lütfen doktor sayfasından giriş yapınız.</div>
      </div>
    );
  }

  const handleGiris = async (e) => {
    e.preventDefault();
    if (!kullaniciAdi) { setHata('Lütfen kullanıcı adı giriniz.'); return; }
    setHata('');
    setYukleniyor(true);
    try {
      const res = await girisYap(kullaniciAdi, parola, siteId);
      localStorage.setItem('kullanici', JSON.stringify(res.data));
      navigate('/');
    } catch {
      setHata('Kullanıcı adı veya şifre hatalı.');
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #e8f4f8 0%, #f0eaff 50%, #eafaf1 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>

        <div style={{ textAlign: 'center', marginBottom: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
          <img src={kelebek} alt="Dr.Plazma" width="50" height="36" />
          <div style={{ fontSize: 26, fontWeight: 800, color: '#3d2f6e' }}>Dr.Plazma</div>
        </div>

        <div style={{
          background: '#fff', borderRadius: 18,
          boxShadow: '0 8px 32px rgba(100,80,200,.12)',
          overflow: 'hidden'
        }}>
          <div style={{ background: 'linear-gradient(135deg, #7C5CBF, #1D9E75)', padding: '18px 24px' }}>
            <div style={{ color: '#fff', fontSize: 17, fontWeight: 700 }}>📋 Personel Girişi</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 3 }}>Sisteme giriş yapın</div>
          </div>

          <form onSubmit={handleGiris} style={{ padding: '22px 24px' }}>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Kullanıcı Adı
              </label>
              <input
                type="text"
                placeholder="Kullanıcı adınızı girin"
                value={kullaniciAdi}
                onChange={e => setKullaniciAdi(e.target.value)}
                required
                autoComplete="username"
                style={{ width: '100%', padding: '11px 12px', border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e', fontWeight: 500, boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Şifre
              </label>
              <input
                type="password"
                placeholder="Şifrenizi girin"
                value={parola}
                onChange={e => setParola(e.target.value)}
                required
                autoComplete="current-password"
                style={{ width: '100%', padding: '11px 12px', border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e', boxSizing: 'border-box' }}
              />
            </div>

            {hata && (
              <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
                {hata}
              </div>
            )}

            <button
              type="submit"
              disabled={yukleniyor}
              style={{
                width: '100%', padding: '13px',
                background: 'linear-gradient(135deg, #7C5CBF, #a07de0)',
                color: '#fff', border: 'none', borderRadius: 10,
                fontSize: 15, fontWeight: 700, cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(124,92,191,.35)'
              }}
            >
              {yukleniyor ? 'Giriş yapılıyor...' : '🔐 GİRİŞ YAP'}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}
